import { ALL_LOCATIONS_ID } from "../constants.js";
import { useLocations } from "../hooks/useLocations.js";
import "react";
import { Skeleton } from "@therms/atalaya";
import { Fragment as Fragment$1, jsx, jsxs } from "react/jsx-runtime";
//#region src/modules/Locations/shared/LocationNames.tsx
var LocationNames = ({ listAll = true, locationIds }) => {
	const allLocations = locationIds.includes(ALL_LOCATIONS_ID);
	const { data, loading } = useLocations({ idFilter: locationIds }, { cacheStrategy: "cache-only" });
	if (allLocations) return /* @__PURE__ */ jsx("span", { children: "All Locations" });
	if (!data?.locations && loading) return /* @__PURE__ */ jsx(Skeleton.Text, { chars: 25 });
	if (!data?.locations || !locationIds?.length) return null;
	if (!listAll && data.total > 1) return /* @__PURE__ */ jsxs("div", {
		className: "flex min-w-0 shrink flex-nowrap",
		children: [/* @__PURE__ */ jsx("div", {
			className: "truncate",
			children: data.locations[0].name
		}), /* @__PURE__ */ jsxs("span", {
			className: "text-info pl-xxs min-w-fit flex-1",
			children: ["+", data.total - 1]
		})]
	});
	return /* @__PURE__ */ jsx(Fragment$1, { children: data.locations.map(({ name }) => name).join(", ") });
};
//#endregion
export { LocationNames };

//# sourceMappingURL=LocationNames.js.map